import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Scroll } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  directives: {
    Scroll,
  },
});

import colors from '@/utils/colors';

export default new Vuetify({
  theme: {
    // dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        primary: colors.primary,
        secondary: colors.secondary,
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
